/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  wijken : data.wijken
}
const getters = {
  getWijkenList: state => {
    return state.wijken;
  },
  getWijkById: state => ({ id }) => {
    return selectOne({
      from: state.wijken, 
      property: 'id', 
      value: id
    });
  },
  getWijkBySlug: state => ({ slug }) => {
    return selectOne({
      from: state.wijken, 
      property: 'slug', 
      value: slug
    });
  },
}
const actions = {}
const mutations = {}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
